import cn from 'classnames';
import styles from './Size.module.scss';
import { SizeType } from '@/types';

type SizeProps = {
  className?: string;
  isUnavailable?: boolean;
  size: SizeType | null;
  isActive?: boolean;
  onClick?: () => void;
};

export function Size({
  className,
  isUnavailable,
  size,
  isActive,
  onClick,
}: SizeProps) {
  const wrapperClassName = cn(
    styles.wrapper,
    {
      [styles.unavailable]: isUnavailable,
      [styles.active]: isActive,
    },
    className,
  );

  return (
    <div className={wrapperClassName} onClick={onClick}>
      <span
        className={cn(styles.text, { [styles.unavailableText]: isUnavailable })}
      >
        {size?.name}
      </span>
      <span
        className={cn(styles.text, { [styles.unavailableText]: isUnavailable })}
      >
        {size?.description}
      </span>
      {isUnavailable && (
        <img
          src="/svg/cross-line.svg"
          alt="cross-line"
          className={styles.crossLine}
        />
      )}
    </div>
  );
}
